import { Loader } from 'braid-design-system';
import React from 'react';

import { CentredBox } from '../CentredBox';

export const PageLoader = () => (
  <CentredBox>
    <Loader delayVisibility />
  </CentredBox>
);
